import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=c29ab58e&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"
import style0 from "./index_new.vue?vue&type=style&index=0&id=c29ab58e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29ab58e",
  null
  
)

export default component.exports